import { render, staticRenderFns } from "./SettingsClinicalUsersBottomPanelLeft.vue?vue&type=template&id=27b76164"
import script from "./SettingsClinicalUsersBottomPanelLeft.vue?vue&type=script&lang=js"
export * from "./SettingsClinicalUsersBottomPanelLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports